import React from 'react';
import { Sheet } from 'react-modal-sheet';
import styled from 'styled-components';
import { rem } from '../../tokens/spacing';

export interface FilterBottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const SheetBody = styled.div`
  padding: ${rem(16)} ${rem(20)} ${rem(20)};
  padding-bottom: max(${rem(20)}, env(safe-area-inset-bottom, ${rem(16)}));
  font-family: var(--ui-font-sans, 'HK Grotesk', sans-serif);
  color: var(--ui-text, inherit);
`;

export function FilterBottomSheet({ open, onClose, children }: FilterBottomSheetProps) {
  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent='content'
      tweenConfig={{ ease: 'easeOut', duration: 0.25 }}
    >
      <Sheet.Container
        style={{
          backgroundColor: 'var(--ui-surface, #ffffff)',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          maxHeight: '85vh',
        }}
      >
        <Sheet.Header />
        <Sheet.Content style={{ overflow: 'auto' }}>
          <SheetBody>{children}</SheetBody>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onClick={onClose} />
    </Sheet>
  );
}
